import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { EBugReportStatus, IBugReport } from '@shared/components/bug-report/bug-report.interface';
import { upperFirst } from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminUserFeedbackService {
  private readonly http = inject(HttpClient);

  public getUserFeedbackList(params?: HttpParams): Observable<IApiResponse<IBugReport[]>> {
    return this.http.get<IApiResponse<IBugReport[]>>('user-feedback', { params });
  }

  public updateUserFeedbackStatus(id: string, status: EBugReportStatus): Observable<IBugReport> {
    return this.http.put<IBugReport>(`user-feedback/${id}/${upperFirst(status)}`, {});
  }
}
